<template>
  <transition name="drawer-fade">
    <div v-if="value" class="custom-drawer-wrapper">
      <div class="drawer-overlay" @click="handleClose"></div>
      <div class="drawer-container">
        <div class="drawer-custom-header">
          <i class="el-icon-close close-btn" @click="handleClose"></i>
          <span class="header-title">新增寵物資料</span>
        </div>

        <div class="drawer-body-scroll">
          <el-form ref="form" :model="submitData" :rules="rules" label-position="top" :validate-on-rule-change="false">
            <div class="avatar-wrapper">
              <BaseUpload v-model="submitData.avatar" resource="pet" circle dir="pet" :limit-size="10" />
            </div>

            <el-form-item label="寵物名" prop="name">
              <el-input v-model="submitData.name" placeholder="請輸入寵物名" />
            </el-form-item>

            <el-form-item label="類別" prop="categoryId">
              <el-select v-model="submitData.categoryId" @change="onCategoryChange" class="w-full" placeholder="請選擇類別">
                <el-option v-for="c in categories" :key="c.id" :label="c.title" :value="c.id" />
              </el-select>
            </el-form-item>

            <el-form-item label="體型" prop="sizeId">
              <el-select v-model="submitData.sizeId" :placeholder="submitData.categoryId ? '請選擇體型' : '請先選擇類別'" class="w-full">
                <el-option v-for="s in sizeOptions" :key="s.id" :label="s.title" :value="s.id" />
              </el-select>
            </el-form-item>

            <el-form-item label="品種">
              <el-input v-model="submitData.breed" placeholder="請輸入品種" />
            </el-form-item>

            <el-form-item label="性別">
              <el-select v-model="submitData.gender" placeholder="請選擇性別" class="w-full">
                <el-option label="女生" value="female" />
                <el-option label="男生" value="male" />
              </el-select>
            </el-form-item>

            <el-form-item label="生日">
              <el-date-picker v-model="submitData.birthday" type="date" value-format="yyyy-MM-dd" placeholder="請選擇生日" class="w-full" />
            </el-form-item>

            <el-divider></el-divider>

            <el-form-item label="行為">
              <div v-for="(item, index) in behaviorItems" :key="index" class="behavior-row">
                <el-checkbox v-model="item.checked" :label="item.title">{{ item.title }}</el-checkbox>
                <el-input v-model="item.text" size="mini" class="behavior-input" placeholder="請輸入說明" />
              </div>
            </el-form-item>

            <el-form-item label="疫苗" class="custom-radio-group">
              <el-radio-group v-model="submitData.questions.vaccine">
                <el-radio :label="0">無</el-radio>
                <el-radio :label="1">1 劑</el-radio>
                <el-radio :label="2">2 劑</el-radio>
                <el-radio :label="3">3 劑</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <div class="drawer-footer">
            <el-button round @click="handleClose">取消</el-button>
            <el-button type="primary" round :loading="loading" @click="handleSave">儲存</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseUpload from '@components/BaseUpload'
export default {
  name: 'PetCreatePartial',
  components: {
    BaseUpload,
  },
  props: {
    value: Boolean,
    memberInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      categories: [],
      behaviorItems: [
        { title: '分離焦慮症', checked: false, text: '' },
        { title: '攻擊過家人', checked: false, text: '' },
        { title: '攻擊陌生人', checked: false, text: '' },
        { title: '攻擊過同類', checked: false, text: '' },
        { title: '被同類咬過', checked: false, text: '' },
      ],
      submitData: this.initForm(),
    }
  },
  computed: {
    sizeOptions() {
      const selectedCat = this.categories.find((c) => c.id === this.submitData.categoryId)
      return selectedCat ? selectedCat.children : []
    },
    rules() {
      return {
        name: [{ required: true, message: '請填寫寵物名', trigger: 'blur' }],
        categoryId: [{ required: true, message: '請選擇類別', trigger: 'change' }],
        sizeId: [{ required: true, message: '請選擇體型', trigger: 'change' }],
      }
    },
  },
  watch: {
    value: {
      handler(isOpen) {
        if (isOpen) {
          this.onPrepareData() // 補回開啟時初始化
        }
      },
      immediate: true,
    },
  },
  methods: {
    initForm() {
      return {
        memberId: this.memberInfo?.id,
        name: '',
        categoryId: '',
        sizeId: '',
        breed: '',
        gender: '',
        birthday: '',
        avatar: '',
        questions: { personality: [], healthy: [], behavior: [], vaccine: 0 },
      }
    },
    async onPrepareData() {
      this.submitData = this.initForm()
      this.behaviorItems.forEach((i) => {
        i.checked = false
        i.text = ''
      })
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
      // 補回抓取類別 API 功能
      try {
        this.categories = await this.$store.dispatch('product/fetchServiceCategory', { paginate: 0 })
      } catch (e) {
        console.error('Fetch categories failed', e)
      }
    },
    onCategoryChange() {
      this.submitData.sizeId = ''
    },
    handleClose() {
      this.$emit('input', false)
      this.$emit('close')
    },
    async handleSave() {
      try {
        await this.$refs.form.validate()
        this.loading = true
        // 補回行為勾選資料處理功能
        this.submitData.questions.behavior = this.behaviorItems.filter((i) => i.checked).map((i) => ({ title: i.title, text: i.text }))

        await this.$store.dispatch('member/storeSinglePet', this.submitData)
        this.$message.success('新增成功')
        this.handleClose()
      } catch (err) {
        console.warn('驗證失敗', err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* 維持你給的樣式，完全不動 */
.custom-drawer-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
}

.drawer-container {
  position: relative;
  width: 45%;
  height: 100%;
  background: #f9f9fb;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 11;
}

.drawer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.drawer-custom-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f2f2f2;
  background: #f9f9f9;
  flex-shrink: 0;
  .close-btn {
    font-size: 32px;
    cursor: pointer;
    margin-right: 15px;
    color: #121931;
  }
  .header-title {
    color: #000000;
    font-weight: 900;
    font-size: 18px;
  }
}

.drawer-body-scroll {
  padding: 30px;
  padding-bottom: 50px;
  flex: 1;
  overflow-y: auto;
  background: #f9f9fb;
}

.avatar-wrapper {
  text-align: center;
  margin-bottom: 25px;
}

.w-full {
  width: 100%;
}

.behavior-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .el-checkbox {
    width: 130px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .behavior-input {
    flex: 1;
  }
}

.drawer-footer {
  margin-top: 40px;
  padding: 20px 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  border-top: 1px solid #f2f2f2;
  ::v-deep button {
    flex: 1;
  }
}

::v-deep .el-form-item__label {
  font-weight: 600;
  padding-bottom: 4px;
}

.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s;
  .drawer-container {
    transition: transform 0.3s ease;
  }
}
.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;
  .drawer-container {
    transform: translateX(100%);
  }
}
</style>
